import axios from '@/api';

const LANG_FIELD = {
    pl: 'statuteLinkPl',
    en: 'statuteLinkEn',
    de: 'statuteLinkDe',
    cz: 'statuteLinkCz',
    fr: 'statuteLinkFr',
    lt: 'statuteLinkLt',
    ua: 'statuteLinkUa',
};

export function langSuffix(lang) {
    const code = String(lang || 'pl').toLowerCase();
    return `${code.charAt(0).toUpperCase()}${code.slice(1)}`;
}

export function statuteLinkField(lang) {
    return LANG_FIELD[String(lang || 'pl').toLowerCase()] || LANG_FIELD.pl;
}

export function statuteFileField(lang) {
    return `statuteFile${langSuffix(lang)}`;
}

export function getStatute(competitionId, lang = 'pl') {
    return axios.get(`panel/competitions/${competitionId}/files/statute`, {
        params: { lang },
    });
}

export function uploadStatute(competitionId, payload, lang = 'pl') {
    return axios.post(`panel/competitions/${competitionId}/files/statute`, payload, {
        params: { lang },
    });
}

export function deleteStatute(competitionId, lang = 'pl') {
    return axios.delete(`panel/competitions/${competitionId}/files/statute`, {
        params: { lang },
    });
}

export function updateStatuteLink(competitionId, lang, value) {
    return axios.put(`panel/competitions/${competitionId}`, {
        [statuteLinkField(lang)]: value,
    });
}
